const state = {
  queues: [],
  attachmentWhatsappAllMidia: [],
  searchConversationDrawer: false,
  conversationList: [],
  conversationByProtocol: [],
  searchConversationTotalPages: null,
  mediaGalleryDialog: {
    imageRef: null,
    status: false,
  },
  forwardMessage: {
    initialized: false,
    dialog: false,
    protocol: null,
    messageList: [],
    activeSessionStatus: [],
  },
};
export default state;
